/**
 * Confirmation dialog component
*/
/* eslint-disable */
import React from 'react';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';

class ConfirmationDialog extends React.Component {
   state = {
      open: false,
   };

   //Define function for open confirmation dialog box
   openDialog() {
      this.setState({ open: true });
   };

   // Close without deleting (No, backdrop, Escape)
   closeDialog() {
      this.setState({ open: false });
      if (this.props.onConfirm) {
         this.props.onConfirm(false);
      }
   };

   // Delete only when Yes is clicked
   confirmDialog() {
      this.setState({ open: false });
      if (this.props.onConfirm) {
         this.props.onConfirm(true);
      }
   };

   render() {
      return (
         <Dialog
            open={this.state.open}
            onClose={() => this.closeDialog()}
            aria-labelledby="responsive-dialog-title"
            className="confirmation-dialog"
         >
            <DialogContent className="p-20 text-center">
               <h4 className="pt-20">Are you sure you want to delete this {this.props.data}?</h4>
            </DialogContent>
            <DialogActions className="px-20 pb-20 justify-content-center">
               <Button
                  onClick={() => this.confirmDialog()}
                  variant="contained"
                  className="btn-primary text-white fw-semi-bold mr-15"
               >
                  Yes
               </Button>
               <Button
                  onClick={() => this.closeDialog()}
                  variant="contained"
                  color="error"
                  className="fw-semi-bold"
               >
                  No
               </Button>
            </DialogActions>
         </Dialog>
      );
   }
}

export default ConfirmationDialog;
